import { SYSTEM_ROLE_TYPES } from "../features/authentication/types/enum";
import { IUserRoles } from "../features/roles";

export const checkIsSuperUser = (currentRoles: IUserRoles[] | undefined) =>
    currentRoles?.map((r) => r.role_id).includes(SYSTEM_ROLE_TYPES.SUPER_USER) || false;
